<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Despachos</h6>
              <router-link
                :to="{ name: 'Remissions Create' }"
                class="btn btn-primary btn-sm"
                data-toggle="tooltip"
                data-original-title="Agregar remisión"
              >
                Agregar <i class="fa fa-plus ms-1"></i>
              </router-link>
            </div>
            <div class="row">
              <!-- Columna de búsqueda -->
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input
                  type="text"
                  v-model="searchQuery"
                  id="searchQuery"
                  class="form-control"
                  placeholder="Buscar remisión..."
                  @input="onSearchInput"
                />
              </div>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      N°</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Nombre</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Email</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Teléfono</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Estado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Observación</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Total</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Fecha</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Copiado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.id }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.name }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.email }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <h6 class="mb-0 text-sm">{{ value.phone }}</h6>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm" :class="value.status == 1 ? 'bg-success' : 'bg-warning'">
                        {{ value.status == 1 ? 'Formalizada' : 'Pendiente' }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        <a @click="viewObservation(value.observation)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          data-original-title="Registro">
                          <i class="fa fa-comment"></i>
                        </a>
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                          minimumFractionDigits: 2, maximumFractionDigits: 2
                        }) }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(value.created_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <i
                        v-if="value.copied_at"
                        class="fas fa-check-circle text-success"
                        style="font-size: 1.1rem;"
                        data-toggle="tooltip"
                        :data-original-title="'Copiado el ' + new Date(value.copied_at).toLocaleString('es-ES')"
                      ></i>
                      <i
                        v-else
                        class="fas fa-clock text-warning"
                        style="font-size: 1.1rem;"
                        data-toggle="tooltip"
                        data-original-title="Pendiente de copiar"
                      ></i>
                    </td>
                    <td class="align-middle text-center">
                      <!-- Si está formalizada, solo mostrar imprimir y ver -->
                      <template v-if="value.status == 1">
                        <a
                          @click="printRemission(value.id)" 
                          class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                          data-toggle="tooltip"
                          data-original-title="Imprimir remisión"
                        >
                          <i class="fas fa-print"></i>
                        </a>
                        
                        <router-link
                          :to="{ name: 'Remissions Create', params: { data: JSON.stringify(value) }, props: true }"
                          class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                          data-original-title="Ver remisión" style="margin-left: 15px;">
                          <i class="fa fa-eye"></i>
                        </router-link>
                      </template>
                      
                      <!-- Si está pendiente, mostrar todas las opciones -->
                      <template v-else>
                        <a
                          @click="printRemission(value.id)" 
                          class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                          data-toggle="tooltip"
                          data-original-title="Imprimir remisión"
                        >
                          <i class="fas fa-print"></i>
                        </a>
                        
                        <router-link
                          :to="{ name: 'Remissions Create', params: { data: JSON.stringify(value) }, props: true }"
                          class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                          data-original-title="Editar Registro" style="margin-left: 15px;">
                          <i class="fa fa-pencil-alt"></i>
                        </router-link>

                        <a @click="deleteUser(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                          style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro">
                          <i class="fa fa-trash"></i>
                        </a>
                      </template>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="10" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: '',
      searchTimeout: null,
    };
  },
  computed: {
    ...mapGetters('remissions', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
      return this.$store.state.remissions.currentPage;
    },
    lastPage() {
      return this.$store.state.remissions.lastPage;
    },
    data() {
      return this.allData;
    },
    links() {
      return this.$store.getters['remissions/links'];
    },
  },
  methods: {
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchData(null);
      }, 400);
    },
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };
      await this.$store.dispatch('remissions/fetchData', params);
    },
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("remissions/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {
            this.fetchData();
            await Swal.fire(
              'Eliminado!',
              'El registro se ha eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async printRemission(id) {
      try {
        const response = await this.$store.dispatch("remissions/getPdf", id);
        
        // Crear una URL del archivo recibido
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        // Crear un enlace para descargar el archivo
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Remision_${id}.pdf`); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
        
        // Limpiar la URL creada
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
      } catch (error) {
        console.error("Error al generar el PDF:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'Error al generar el PDF de la remisión',
        });
      }
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}
</style>
